import React from "react";

/**
 * @name CCTM_item
 * @function
 * @extends React.Component
 * @exported true
 * @description This component dynamically renders a given component and allows optional post-processing.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.component - The component to be rendered.
 * @param {Function} [props.postRender] - Optional function to modify the component before rendering.
 * @example
 * export default function CCTM_item(props) {
 *  return (
 *    <CCTM_item component={MyComponent} postRender={(comp, props) => modifyComponent(comp, props)} />
 *  );
 * }
 */

export default function CCTM_item(props) {
    
    // Extract the component from props
    let Component = props.component;
    
    // If a postRender function is provided, use it to modify the component before rendering
    if (typeof props.postRender == "function") {
        Component = props.postRender(props.component, props);
    }
    
    // Render the component with the given props
    return <Component {...props} />;
}
